import React from 'react';
import { useState } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Button, Flex, Text } from 'rebass';
import withSession from '../../../lib/withSession';
import { DurationSelectionWithKit } from './DurationSelection';
import { UpgradePro } from './UpgradePro';
import { useEffect } from 'react';
import { Mutation } from 'react-apollo';
import { CREATE_SESSION_GI_CHECKOUT_SESSION } from '../../../graphql';
import { ShippingAddress } from './ShippingAddress';
import { CompleteKit } from './CompleteKit';

export const SUBSCRIBE_GUT_RESET_WITH_KITS_URL = '/programs/gut-reset/subscribe/with-kit';

const GuardedRoute = ({ condition, redirect, children }) => {
  if (!condition) return <Redirect to={redirect} />;
  return children;
};

const SubscribedWithKits = ({ history }) => {
  const [duration, setDuration] = useState();
  const [upgradePro, setUpgradePro] = useState(null);

  return (
    <>
      <Route
        path={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/`}
        exact
        render={(props) => (
          <Flex flexDirection={'column'}>
            <DurationSelectionWithKit
              onContinue={(d) => {
                setDuration(d);
                if (d) {
                  history.push(`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/upgrade`);
                }
              }}
            />
          </Flex>
        )}
      />
      <Route
        path={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/upgrade`}
        render={(props) => (
          <Flex flexDirection={'column'}>
            <GuardedRoute condition={!!duration} redirect={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/`}>
              {' '}
              <Mutation
                mutation={CREATE_SESSION_GI_CHECKOUT_SESSION}
                onCompleted={async (res) => {
                  let sessionId = null;
                  if (res.createGiCheckoutSession) {
                    sessionId = res.createGiCheckoutSession.sessionId;
                  }
                  if (!sessionId) {
                    return;
                  }
                  const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
                  const stripe = await stripePromise;
                  await stripe.redirectToCheckout({
                    sessionId: sessionId,
                  });
                }}
              >
                {(createSession, { loading }) => (
                  <UpgradePro
                    continueWithProKit={() => {
                      // setUpgradePro(true);
                      // history.push(`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/shipping-address`);
                      createSession({
                        variables: {
                          forwardUrl: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`,
                          cancel_url: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/`,
                          duration: duration,
                          // withKit: true,
                          // upgradeProKit: true,
                          // ...values,
                        },
                      });
                    }}
                    continueWithoutProKit={() => {
                      // setUpgradePro(false);
                      // history.push(`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/shipping-address`);
                      createSession({
                        variables: {
                          forwardUrl: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`,
                          cancel_url: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/`,
                          duration: duration,
                          // withKit: true,
                          // upgradeProKit: false,
                        },
                      });
                    }}
                  />
                )}
              </Mutation>
            </GuardedRoute>
          </Flex>
        )}
      />
      <Route
        path={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`}
        render={(props) => (
          // <GuardedRoute condition={upgradePro !== null} redirect={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`}>
            <CompleteKit />
          // </GuardedRoute>
        )}
      />
      <Route
        path={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/shipping-address`}
        render={(props) => (
          <GuardedRoute condition={upgradePro !== null} redirect={`${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/upgrade`}>
            <Flex flexDirection={'column'}>
              <Mutation
                mutation={CREATE_SESSION_GI_CHECKOUT_SESSION}
                onCompleted={async (res) => {
                  let sessionId = null;
                  if (res.createGiCheckoutSession) {
                    sessionId = res.createGiCheckoutSession.sessionId;
                  }
                  if (!sessionId) {
                    return;
                  }
                  const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
                  const stripe = await stripePromise;
                  await stripe.redirectToCheckout({
                    sessionId: sessionId,
                  });
                }}
              >
                {(createSession, { loading }) => (
                  <ShippingAddress
                    onContinue={(values) => {
                      createSession({
                        variables: {
                          forwardUrl: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/complete`,
                          cancel_url: `${SUBSCRIBE_GUT_RESET_WITH_KITS_URL}/`,
                          duration: duration,
                          withKit: true,
                          upgradeProKit: !!upgradePro,
                          ...values,
                        },
                      });
                    }}
                  />
                )}
              </Mutation>
            </Flex>
          </GuardedRoute>
        )}
      />
    </>
  );
};

export default withRouter(withSession(SubscribedWithKits));
